export var trim = function trim(str) {
  return str.trim();
};
export var stripPort = function stripPort() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return host.replace(/:\d+$/, '');
};